import React from 'react';
import { useNavigate } from 'react-router-dom';
import Post from './Post';
import PostSkeleton from './PostSkeleton';
import { PostProps } from '../../../../types/postType';
import { UserType } from '../../../../types/userType';

interface PostViewerProps {
  post: PostProps | null;
  currentUser: UserType | null;
  isLoading: boolean;
  onApplyClick: () => void;
}

const PostViewer: React.FC<PostViewerProps> = ({ 
  post, 
  currentUser, 
  isLoading,
  onApplyClick 
}) => {
  const navigate = useNavigate();
  
  if (isLoading) {
    return <PostSkeleton />;
  }

  if (!post) {
    return null;
  }

  return (
    <div className="post-details-post">
      <Post 
        {...post} 
        currentUser={currentUser}
        currentUserId={currentUser?.id?.toString() ?? ''}
        onPostDeleted={() => navigate('/')}
        isNewPost={false}
        onReplyClick={() => {}}
        isInPostDetails={true}
        onApplyClick={onApplyClick}
      />
    </div>
  );
};

export default PostViewer; 